// @react/hooks/useBillingBillingAccount.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { billingBillingAccountStore } from '@core/stores';

/**
 * React hook for BillingAccount operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useBillingBillingAccount } from '@react/hooks';
 *
 * const BillingAccountList = observer(() => {
 *   const store = useBillingBillingAccount();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useBillingBillingAccount() {
  return billingBillingAccountStore;
}
